import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Globals from '../../core/globals';
import { useNavigate } from 'react-router-dom';

function Login() {
    const navigate = useNavigate();
    useEffect(() => {
        if (typeof window !== 'undefined' && localStorage.getItem('authToken')) {
            navigate('/events', { replace: true });
        }
    }, [navigate]);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            const response = await axios.post(Globals.backendUri + '/authentication', { email, password });
            localStorage.setItem('authToken', response.data);
            navigate('/events', { replace: true });
        } catch (err) {
            setError(err.response?.data || 'Invalid email or password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white min-h-screen flex items-center">
            <div className="w-full px-6">
                <h1 className="text-3xl font-bold mb-6">Welcome</h1>
                {error ? <div className="mb-3 text-red-600">{error}</div> : null}
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="block text-sm text-gray-700 mb-1" htmlFor="email">E-Mail</label>
                        <input id="email" type="email" className="w-full border rounded-md px-4 py-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail" />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-700 mb-1" htmlFor="password">Password</label>
                        <input id="password" type="password" className="w-full border rounded-md px-4 py-3" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" />
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white rounded-md py-3 text-base" disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;


